(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[236],{

/***/ 5327:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shell",
      function () {
        return __webpack_require__(6825);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9939:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AdbTerminal": function() { return /* binding */ AdbTerminal; }
/* harmony export */ });
/* harmony import */ var _yume_chan_adb__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7417);
/* harmony import */ var _yume_chan_event__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2469);
/* harmony import */ var _yume_chan_stream_extra__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6261);
/* harmony import */ var xterm__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8425);
/* harmony import */ var xterm__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(xterm__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var xterm_addon_fit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8711);
/* harmony import */ var xterm_addon_fit__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(xterm_addon_fit__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var xterm_addon_search__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2923);
/* harmony import */ var xterm_addon_search__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(xterm_addon_search__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var xterm_addon_webgl__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8874);
/* harmony import */ var xterm_addon_webgl__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(xterm_addon_webgl__WEBPACK_IMPORTED_MODULE_6__);
// cspell: ignore scrollback







class AdbTerminal extends _yume_chan_event__WEBPACK_IMPORTED_MODULE_1__/* .AutoDisposable */ .Xn {
    get socket() {
        return this._socket;
    }
    set socket(value) {
        if (this._socket) {
            var ref;
            // Remove event listeners
            this.dispose();
            (ref = this._socketAbortController) === null || ref === void 0 ? void 0 : ref.abort();
        }
        this._socket = value;
        if (value) {
            this.terminal.clear();
            this.terminal.reset();
            this._socketAbortController = new _yume_chan_stream_extra__WEBPACK_IMPORTED_MODULE_2__/* .AbortController */ .HS();
            // pty mode only has one stream
            value.stdout.pipeTo(new _yume_chan_stream_extra__WEBPACK_IMPORTED_MODULE_2__/* .WritableStream */ .Vj({
                write: (chunk)=>{
                    this.terminal.write(chunk);
                }
            }), {
                signal: this._socketAbortController.signal
            });
            const _writer = value.stdin.getWriter();
            this.addDisposable(this.terminal.onData((data)=>{
                const buffer = (0,_yume_chan_adb__WEBPACK_IMPORTED_MODULE_0__/* .encodeUtf8 */ .lz)(data);
                _writer.write(buffer);
            }));
            this.fit();
        }
    }
    setContainer(container) {
        container.appendChild(this.element);
        if (!this.terminal.element) {
            void this.element.offsetWidth;
            this.terminal.open(this.element);
            // WebGL addon requires terminal to be attached to DOM
            this.terminal.loadAddon(new xterm_addon_webgl__WEBPACK_IMPORTED_MODULE_6__.WebglAddon());
            // WebGL renderer ignores `cursorBlink` set before it initialized
            this.terminal.options.cursorBlink = true;
            this.fit();
        }
    }
    fit() {
        var ref;
        this.fitAddon.fit();
        // Resize remote terminal
        const { rows , cols  } = this.terminal;
        (ref = this._socket) === null || ref === void 0 ? void 0 : ref.resize(rows, cols);
    }
    constructor(){
        super();
        this.element = document.createElement("div");
        this.terminal = new xterm__WEBPACK_IMPORTED_MODULE_3__.Terminal({
            allowProposedApi: true,
            allowTransparency: true,
            cursorStyle: "bar",
            cursorBlink: true,
            fontFamily: '"Cascadia Code", Consolas, monospace, "Source Han Sans SC", "Microsoft sans-serif"',
            letterSpacing: 1,
            scrollback: 9000,
            smoothScrollDuration: 50,
            overviewRulerWidth: 20
        });
        this.searchAddon = new xterm_addon_search__WEBPACK_IMPORTED_MODULE_5__.SearchAddon();
        this.fitAddon = new xterm_addon_fit__WEBPACK_IMPORTED_MODULE_4__.FitAddon();
        this.element.style.width = "100%";
        this.element.style.height = "100%";
        this.element.style.overflow = "hidden";
        this.terminal.loadAddon(this.searchAddon);
        this.terminal.loadAddon(this.fitAddon);
    }
}


/***/ }),

/***/ 6825:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4471);
/* harmony import */ var _fluentui_react__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(1887);
/* harmony import */ var _fluentui_react__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(9899);
/* harmony import */ var _fluentui_react__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(7162);
/* harmony import */ var _fluentui_react__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(1197);
/* harmony import */ var _griffel_react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(9332);
/* harmony import */ var _griffel_react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(8186);
/* harmony import */ var mobx__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(6323);
/* harmony import */ var mobx_react_lite__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6779);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3591);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3370);
/* harmony import */ var xterm_css_xterm_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1714);
/* harmony import */ var xterm_css_xterm_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(xterm_css_xterm_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4347);
/* harmony import */ var _state__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2344);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5155);
/* harmony import */ var _yume_chan_stream_extra__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(6261);
/* harmony import */ var path__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8126);
/* harmony import */ var path__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(path__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _yume_chan_adb__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(7417);














const useClasses = (0,_griffel_react__WEBPACK_IMPORTED_MODULE_11__/* .makeStyles */ .Z)({
    count: {
        ..._griffel_react__WEBPACK_IMPORTED_MODULE_12__/* .shorthands.padding */ .q5.padding("0", "0")
    }
});
let terminal;
if (true) {
    const { AdbTerminal  } = __webpack_require__(9939);
    terminal = new AdbTerminal();
    window.terminal = terminal;
}
const SEARCH_OPTIONS = {
    decorations: {
        matchBackground: "#42557b",
        matchOverviewRuler: "#d18616",
        activeMatchBackground: "#6199ff2f",
        activeMatchColorOverviewRuler: "#d186167e"
    }
};
const state = (0,mobx__WEBPACK_IMPORTED_MODULE_13__/* .makeAutoObservable */ .ky)({
    visible: false,
    index: undefined,
    count: undefined,
    setVisible (value) {
        this.visible = value;
    },
    searchKeyword: "",
    setSearchKeyword (value) {
        this.searchKeyword = value;
        terminal.searchAddon.findNext(value, {
            ...SEARCH_OPTIONS,
            incremental: true
        });
    },
    searchPrevious () {
        terminal.searchAddon.findPrevious(this.searchKeyword, SEARCH_OPTIONS);
    },
    searchNext () {
        terminal.searchAddon.findNext(this.searchKeyword, SEARCH_OPTIONS);
    }
}, {
    searchPrevious: mobx__WEBPACK_IMPORTED_MODULE_13__/* .action.bound */ .aD.bound,
    searchNext: mobx__WEBPACK_IMPORTED_MODULE_13__/* .action.bound */ .aD.bound
});
if (terminal) {
    terminal.searchAddon.onDidChangeResults((e)=>{
        console.log(e);
        (0,mobx__WEBPACK_IMPORTED_MODULE_13__/* .runInAction */ .z)(()=>{
            if (e) {
                state.index = e.resultIndex;
                state.count = e.resultCount;
            } else {
                state.index = undefined;
                state.count = undefined;
            }
        });
    });
}
(0,mobx__WEBPACK_IMPORTED_MODULE_13__/* .autorun */ .EH)(()=>{
    if (!terminal) {
        return;
    }
    if (!_state__WEBPACK_IMPORTED_MODULE_6__/* .GlobalState.device */ .q.device) {
        terminal.socket = undefined;
        return;
    }
    if (!terminal.socket && state.visible) {
        var ref;
        (ref = _state__WEBPACK_IMPORTED_MODULE_6__/* .GlobalState.device */ .q.device) === null || ref === void 0 ? void 0 : ref.subprocess.shell().then((0,mobx__WEBPACK_IMPORTED_MODULE_13__/* .action */ .aD)((shell)=>{
            terminal.socket = shell;
        }), (e)=>{
            _state__WEBPACK_IMPORTED_MODULE_6__/* .GlobalState.showErrorDialog */ .q.showErrorDialog(e);
        });
    }
});
const UpIconProps = {
    iconName: _utils__WEBPACK_IMPORTED_MODULE_7__/* .Icons.ChevronUp */ .PJ.ChevronUp
};
const DownIconProps = {
    iconName: _utils__WEBPACK_IMPORTED_MODULE_7__/* .Icons.ChevronDown */ .PJ.ChevronDown
};
const Shell = ()=>{
    const classes = useClasses();
    const handleSearchKeywordChange = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)((e, value)=>{
        state.setSearchKeyword(value !== null && value !== void 0 ? value : "");
    }, []);
    const handleResize = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(()=>{
        terminal.fit();
    }, []);
    const handleContainerRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)((container)=>{
        if (container) {
            terminal.setContainer(container);
        }
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(()=>{
        state.setVisible(true);
        return ()=>{
            state.setVisible(false);
        };
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(()=>{
        if (true) {
            window.upload = async (file, apath)=>{
                const sync = await _state__WEBPACK_IMPORTED_MODULE_6__/* .GlobalState.device.sync */ .q.device.sync();
                try {
                    const itemPath = path__WEBPACK_IMPORTED_MODULE_9___default().resolve(apath, file.name);
                    // runInAction(() => {
                    //     this.uploading = true;
                    //     this.uploadPath = file.name;
                    //     this.uploadedSize = 0;
                    //     this.uploadTotalSize = file.size;
                    //     this.debouncedUploadedSize = 0;
                    //     this.uploadSpeed = 0;
                    // });
                    // const intervalId = setInterval(action(() => {
                    //     this.uploadSpeed = this.uploadedSize - this.debouncedUploadedSize;
                    //     this.debouncedUploadedSize = this.uploadedSize;
                    // }), 1000);
                    try {
                        await (0,_utils__WEBPACK_IMPORTED_MODULE_7__/* .createFileStream */ .Xd)(file).pipeThrough(new _yume_chan_stream_extra__WEBPACK_IMPORTED_MODULE_8__/* .ChunkStream */ .Cc(_yume_chan_adb__WEBPACK_IMPORTED_MODULE_10__/* .ADB_SYNC_MAX_PACKET_SIZE */ .j4)).pipeThrough(new _utils__WEBPACK_IMPORTED_MODULE_7__/* .ProgressStream */ .hK((0,mobx__WEBPACK_IMPORTED_MODULE_13__/* .action */ .aD)((uploaded)=>{
                        //this.uploadedSize = uploaded;
                        }))).pipeTo(sync.write(itemPath, _yume_chan_adb__WEBPACK_IMPORTED_MODULE_10__/* .LinuxFileType.File */ .d6.File << 12 | 438, file.lastModified / 1000));
                        (0,mobx__WEBPACK_IMPORTED_MODULE_13__/* .runInAction */ .z)(()=>{
                        // this.uploadSpeed = this.uploadedSize - this.debouncedUploadedSize;
                        // this.debouncedUploadedSize = this.uploadedSize;
                        });
                    } finally{
                    //clearInterval(intervalId);
                    }
                } catch (e) {
                    //GlobalState.showErrorDialog(e);
                    return e;
                } finally{
                    var ref;
                    sync.dispose();
                    await ((ref = _state__WEBPACK_IMPORTED_MODULE_6__/* .GlobalState.device */ .q.device) === null || ref === void 0 ? void 0 : ref.subprocess.shell("sync ;").then((0,mobx__WEBPACK_IMPORTED_MODULE_13__/* .action */ .aD)((shell)=>{}), (e)=>{}));
                // this.loadFiles();
                // runInAction(() => {
                //     this.uploading = false;
                // });
                }
            };
            window.device = _state__WEBPACK_IMPORTED_MODULE_6__/* .GlobalState.device */ .q.device;
            window.terminal = terminal;
        }
    }, [
        _state__WEBPACK_IMPORTED_MODULE_6__/* .GlobalState.device */ .q.device,
        terminal
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_fluentui_react__WEBPACK_IMPORTED_MODULE_14__/* .Stack */ .K, {
        ..._utils__WEBPACK_IMPORTED_MODULE_7__/* .RouteStackProps */ .LE,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                    children: "Interactive Shell - Android Web Toolbox"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fluentui_react__WEBPACK_IMPORTED_MODULE_15__/* .StackItem */ .v, {
                style: {
                    display: "none"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_fluentui_react__WEBPACK_IMPORTED_MODULE_14__/* .Stack */ .K, {
                    horizontal: true,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fluentui_react__WEBPACK_IMPORTED_MODULE_15__/* .StackItem */ .v, {
                            grow: true,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fluentui_react__WEBPACK_IMPORTED_MODULE_16__/* .SearchBox */ .R, {
                                placeholder: "Find",
                                value: state.searchKeyword,
                                onChange: handleSearchKeywordChange,
                                onSearch: state.searchNext
                            })
                        }),
                        state.count === 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fluentui_react__WEBPACK_IMPORTED_MODULE_15__/* .StackItem */ .v, {
                            className: classes.count,
                            align: "center",
                            children: "No results"
                        }) : state.count !== undefined ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_fluentui_react__WEBPACK_IMPORTED_MODULE_15__/* .StackItem */ .v, {
                            className: classes.count,
                            align: "center",
                            children: [
                                state.index + 1,
                                " of ",
                                state.count
                            ]
                        }) : null,
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fluentui_react__WEBPACK_IMPORTED_MODULE_15__/* .StackItem */ .v, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fluentui_react__WEBPACK_IMPORTED_MODULE_17__/* .IconButton */ .h, {
                                disabled: !state.searchKeyword,
                                iconProps: UpIconProps,
                                onClick: state.searchPrevious
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fluentui_react__WEBPACK_IMPORTED_MODULE_15__/* .StackItem */ .v, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fluentui_react__WEBPACK_IMPORTED_MODULE_17__/* .IconButton */ .h, {
                                disabled: !state.searchKeyword,
                                iconProps: DownIconProps,
                                onClick: state.searchNext
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_fluentui_react__WEBPACK_IMPORTED_MODULE_15__/* .StackItem */ .v, {
                grow: true,
                styles: {
                    root: {
                        position: "relative",
                        minHeight: 0,
                        padding: 0,
                        margin: "0 !important"
                    }
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_5__/* .ResizeObserver */ ["do"], {
                        onResize: handleResize
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        ref: handleContainerRef,
                        style: {
                            height: "100%"
                        }
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = ((0,mobx_react_lite__WEBPACK_IMPORTED_MODULE_1__/* .observer */ .Pi)(Shell));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [470,988,774,888,179], function() { return __webpack_exec__(5327); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);